import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Grid,
  useTheme,
} from "@mui/material";
import {
  hashCurrencyEnumString,
  hashExchangeEnumReverse,
  hashInvestmentReverse,
  inputChecker,
} from "../../../component/Methods";
import Rebalance from "./Rebalance";
import {
  addActiveRequests,
  updateLoading,
  updateLoadingMsg,
} from "../../../Redux/Reducers/uiSlice";
import { useDispatch, useSelector } from "react-redux";
import { uploadToS3 } from "../../../utils/s3Upload";
import { toast } from "react-toastify";
import { getPayloadSize, payloadQualifiesForS3Upload } from "../../../component/Methods/checks";
import { sendWebSocketMessage } from "../../../hooks/useWebSocket";


const SaveSignals = ({
  title,
  saveChange,
  setSaveChange,
  data,
  setpasted,
  strategyValObj,
}) => {
  const theme = useTheme();
  const [saveRebalancer, setSaveRebalancer] = useState(false);
  const dispatch = useDispatch();

  const { userInfo ,apiInfo} = useSelector((state) => state?.users);


  const handleMe = async () => {
    setSaveRebalancer(false);
    const updatedData = data?.map((item) => {
      const { ticker } = inputChecker(item?.name);
      const { symbol, currency ,country, stock } = ticker;
      if (stock) {
        item.stock = stock;
      }

      item.symbol = symbol;
      item.currency = currency;
      item.investment = item.investment;
      item.country = country;

      return item;
    });


    if (updatedData && updatedData.length > 0 && strategyValObj) {
      const strategy = strategyValObj ? strategyValObj : "";
      const signals = updatedData?.map((item) => {
        const signal = {
          key: {
            currency: hashCurrencyEnumString(item?.currency) || 7,
            exchange: hashExchangeEnumReverse(item?.country) || 4,
             investment: (typeof item?.investment === 'string' ? hashInvestmentReverse(item?.investment) : item?.investment) || 4,
            //investment:item?.investment || 4,
            symbol: item?.symbol,
          },
          value: parseFloat(item.value) / 100,
        };

        if (item?.stock) {
          signal.key.stock = item?.stock;
        }

        return signal;
      });

      const webSocketPayload = {
        action: "new_signal",
        data: {
          strategy: strategy,
          signals: signals,
        },
      };

      if (payloadQualifiesForS3Upload(getPayloadSize(webSocketPayload))) {
        try {
       
          const s3Result = await uploadToS3(
            webSocketPayload, 
            apiInfo, 
            userInfo, 
            'new_signal'
          );

          if (s3Result.success) {
        
            const s3ReferencePayload = {
              action: "new_signal",
              file: s3Result.fileName,
            };
            sendWebSocketMessage(JSON.stringify(s3ReferencePayload));
          } 
          else {
            toast.error("Failed to upload signals to S3. Please try again later.");
          }
        } 
        catch (error) {
          toast.error("Failed to upload signals to S3. Please try again later.");
        }
      } 
      else {
        const payloadString = JSON.stringify(webSocketPayload);
        sendWebSocketMessage(payloadString);
      }

      dispatch(addActiveRequests("new_signal"));
      dispatch(updateLoading(true));
      dispatch(updateLoadingMsg("Saving Signals"));
    } 
    else {
      console.error(
        "Unable to send data to socket: Invalid pastedArray or strategyValObj"
      );
    }

    setpasted(updatedData);
  };
  return (
    <>
      <Dialog
        open={saveChange}
        maxWidth="xs"
        onClick={() => {
          setSaveChange(false);
        }}
      >
        <DialogTitle>
          <Typography
            variant="h6"
            component="div"
            align="center"
            style={{ flexGrow: 1, fontSize: "20px" }}
          >
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ px: 8 }}>
        
          <Grid
            item
            xs={12}
            margin="20px 1px 20px 1px "
            display="flex"
            justifyContent="space-between"
          >
            <Button
              variant="contained"
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                height: "40px",
                width: "150px",
                background: "#B2BEB5",
                color: "#000",
                mr:2,
                "&:hover": { background: "#808080" },
              }}
              onClick={() => {
                setSaveChange(false);
              }}
            >
              CANCEL CHANGES
            </Button>
            <Button
              variant="contained"
              color="success"
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                height: "40px",
                width: "150px",
              }}
              onClick={() => {
                handleMe();
              }}
            >
              SAVE CHANGES
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
      <Rebalance
        saveRebalancer={saveRebalancer}
        setSaveRebalancer={setSaveRebalancer}
        title="Rebalance"
      />
    </>
  );
};
export default SaveSignals;